export default __webpack_public_path__ + "static/media/logo-maccaferri.f98931b8.png";